import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { UsersTable } from '../../features/users'

export const Table = (props: RouteProps) => {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <UsersTable />
    </>
  )
}
